<template>
  <div style="max-width: 600px;">
    <b-dropdown
      ref="dateDropdown"
      auto-close="false"
      menu-class="p-3"
      variant="outline-primary"
      toggle-class="w-100 d-flex justify-content-between align-items-center border rounded px-3 py-2"
      no-caret
    >
      <!-- Affichage personnalisé du bouton -->
      <template #button-content>
        <span>
          <span v-if="startDate && endDate">
            {{ startDate }} → {{ endDate }}
          </span>
          <span v-else class="text-muted">Date / Période</span>
        </span>
        <b-icon icon="chevron-down"></b-icon>
      </template>

      <!-- Contenu du menu déroulant -->
      <div style="min-width: 600px;" class="d-flex flex-row justify-content-between gap-3">
        <div style="flex: 1;" class="mr-1">
          <label class="font-weight-bold mb-2 d-block text-center">Début</label>
          <b-calendar
            v-model="startDate"
            :max="endDate"
            locale="fr"
            hide-header
            block
          ></b-calendar>
        </div>

        <div style="flex: 1;" class="ml-1">
          <label class="font-weight-bold mb-2 d-block text-center">Fin</label>
          <b-calendar
            v-model="endDate"
            :min="startDate"
            locale="fr"
            hide-header
            block
          ></b-calendar>
        </div>
      </div>

      <!-- Bouton de validation -->
      <b-button
        size="sm"
        variant="outline-primary"
        block
        class="mt-3"
        @click="closeDropdown"
      >
        Valider
      </b-button>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {
      startDate: null,
      endDate: null,
    };
  },

  emits: ['updatePeriode'],

  methods: {
    closeDropdown() {
      this.$emit('updatePeriode', this.startDate, this.endDate);
      this.$refs.dateDropdown.hide();
    },

 
    reset() {
      this.startDate = null;
      this.endDate = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/b122/editFields/MultiDatePickerInput.vue